export const LOYALTY_CATEGORIES = ["0", "1", "2", "3", "4", "5+"];
